export default __webpack_public_path__ + "static/media/landscape29.fee93c43.JPG";